import styled from "styled-components";
import { getTheme, Div, } from "@bracket/ui";
import type { FunctionComponent, ReactNode } from "react";


export declare type CheckboxProps = {
	label: string | ReactNode;
	labelId: string;
	size?: number;
	checked?: boolean;
	onChange?: () => void;
};

export const Checkbox: FunctionComponent<CheckboxProps> = ({
	label,
	labelId,
	size = 24,
	checked,
	onChange,
}) => {

	const inputProps = {
		type: "checkbox",
		id: labelId,
		onClick: onChange,
		...(checked !== undefined ? { checked, readOnly: true, } : {}),
	};

	return (
		<Brace onClick={(e) => e.stopPropagation()}>
			<StyledInput {...inputProps} />
			<StyledLabel htmlFor={labelId}>
				<CheckboxBox $size={size}>
					<CheckIcon $size={size}>✔</CheckIcon>
				</CheckboxBox>
				{label}
			</StyledLabel>
		</Brace>
	);
};

const Brace = styled(Div)`
`;

const StyledLabel = styled.label`
	display: flex;
	position: relative;
	align-items: center;
	gap: 12px;
	cursor: pointer;
	user-select: none;
`;

const CheckIcon = styled.div<{ $size: number }>`
	position: absolute;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	color: ${() => getTheme().paragraph};
	transition: all 0.2s;
	font-size: ${({ $size }) => $size * 0.75}px;
`;

const CheckboxBox = styled.div<{ $size: number }>`
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
	width: ${({ $size }) => $size}px;
	height: ${({ $size }) => $size}px;
	border: 1px solid ${() => getTheme().outline};
	border-radius: 4px;
	background: transparent;
	min-width: ${({ $size }) => $size}px;
	min-height: ${({ $size }) => $size}px;
	flex-shrink: 0;
`;

const StyledInput = styled.input`
	position: absolute;
	opacity: 0;
	width: 0;
	height: 0;
	&:not(:checked) + label ${CheckIcon} {
		opacity: 0;
		transform: scale(0);
	}
	&:checked + label ${CheckIcon} {
		opacity: 1;
		transform: scale(1);
	}
	&:focus-visible + label ${CheckboxBox} {
		outline: 2px solid Highlight;
		outline: 2px solid -webkit-focus-ring-color;
		outline-offset: 2px;
	}
`;
